import React, { createContext, useContext, useEffect, useState } from 'react';

interface CheckpointsContextType {
  items: string[];
  addItem: (item: string) => void;
  clearItems: () => void;
}

const CheckpointsContext = createContext<CheckpointsContextType | undefined>(
  undefined
);

export const CheckpointsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [items, setItems] = useState<string[]>(() => {
    const stored = localStorage.getItem('checkpoints');
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem('checkpoints', JSON.stringify(items));
  }, [items]);

  const addItem = (item: string) => {
    setItems((prev) => [...prev, item]);
  };

  const clearItems = () => {
    setItems([]);
    localStorage.removeItem('checkpoints');
  };

  return (
    <CheckpointsContext.Provider value={{ items, addItem, clearItems }}>
      {children}
    </CheckpointsContext.Provider>
  );
};

export const useCheckpoints = () => {
  const context = useContext(CheckpointsContext);
  if (context === undefined) {
    throw new Error('useCheckpoints must be used within a CheckpointsProvider');
  }
  return context;
};
